import { DIValidators, EFeatureFlags, IF360Sidebar } from "@/core/@types/types";
import { type IF360FeatureFlagValidator } from "@/core/validators/F360FeatureFlagValidator";
import { type IF360Validator } from "@/core/validators/F360Validator";
import { type IUsuarioAdminValidator } from "@/core/validators/usuarioAdmin/IUsuarioAdminValidator";
import { inject, injectable } from "inversify";

import "reflect-metadata";
@injectable()
export default abstract class F360Sidebar {
  @inject(DIValidators.CIELO)
  private cieloValidator!: IF360Validator;

  @inject(DIValidators.CADIS)
  private cadisValidator!: IF360Validator;

  @inject(DIValidators.FEATURE_FLAGS)
  private featureFlagValidator!: IF360FeatureFlagValidator;

  @inject(DIValidators.SHOW_EDUCA)
  private showEducaValidator!: IF360Validator;

  @inject(DIValidators.USUARIO_ADMIN)
  private usuarioAdminValidator!: IUsuarioAdminValidator;

  @inject(DIValidators.SYS_ADMIN)
  private readonly sysAdminValidator!: IF360Validator;

  protected isCielo() {
    return this.cieloValidator.handleValidation();
  }

  protected isCadis() {
    return this.cadisValidator.handleValidation();
  }

  protected hasAntecipaFeatureFlag() {
    return this.featureFlagValidator.handleValidationByName(
      EFeatureFlags.telaAntecipa
    );
  }

  protected showEduca() {
    return this.showEducaValidator.handleValidation();
  }

  protected isSysAdmin() {
    return this.sysAdminValidator.handleValidation();
  }

  protected isUsuarioAdmin() {
    return this.usuarioAdminValidator.handle();
  }

  protected handleFinancasURL = (url: string) => `/${url}`;

  abstract handleSidebar(): Array<IF360Sidebar>;
}
